import React from "react";
import Select from "react-select";

const customStyles = {
  control: (provided) => ({
    ...provided,
    fontSize: "14px",
    minHeight: "40px",
    borderRadius: "8px",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "14px",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "14px",
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "14px",
  }),
};

const assetsOptions = [
  { value: "68B6B33B7E88", label: "68B6B33B7E88" },
  { value: "Ciocca_Subfeed_Two", label: "Ciocca_Subfeed_Two" },
  { value: "68B6B33DB080", label: "68B6B33DB080" },
  { value: "68B6B33DB084", label: "68B6B33DB084" },
  { value: "68B6B33DB06C1", label: "68B6B33DB06C1" },
];

const CustomMultiSelect = () => (
  <Select
    defaultValue={[assetsOptions[2], assetsOptions[3]]}
    isMulti
    name="colors"
    options={assetsOptions}
    className="basic-multi-select"
    classNamePrefix="select"
    isClearable={true}
    placeholder="Select assets"
    styles={customStyles}
  />
);

export default CustomMultiSelect;
